module.exports = __webpack_public_path__ + "chambre.png?812e36f585b430f56d8a0d8a7d74df15";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/upload_images/offers/chambre.png
// module id = 57
// module chunks = 13